'use strict';
class DeveloperDashboardController {

    constructor($timeout, $localStorage, SSHttpService, SSUtilService, SSAnalyticsService, SSUserService, SSAppService, SSAlertService) {
        const self = this;

        self.$timeout = $timeout;
        self.$localStorage = $localStorage;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAnalyticsService = SSAnalyticsService;
        self.SSUserService = SSUserService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;      

        // Constants
        self.PROPERTY_STATUS_APPROVED = SHOWSUITE.PROPERTY_STATUS_APPROVED;
        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED;
        self.PROPERTY_STATUS_ARCHIVED = SHOWSUITE.PROPERTY_STATUS_ARCHIVED;

        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
        self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

        self.BUTTON_MARKETING = 1;
        self.BUTTON_SALES = 2;
        self.limit=10;
        self.show='sales-data';
        self.gdData=null;
        self.gd=null;
        self.gdInitDate=null;
        self.gdDetailData=null;

        self.shortcut_offset = 0;
        self.shortcut_limit = 2;
        self.total_shortcuts = 0;

        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.DMSSelectedTab = 1;
        }

        self.directToPhase = 1;
        self.directToUnit = 2;

        self.SHORTCUT_PROPERTY_TYPE = SHOWSUITE.SHORTCUT_PROPERTY_TYPE;

        self.gst_inclusive = true;
    }

    init() {
        const self = this;
        // Trigger View Event for Dashboard
        self.SSAnalyticsService.saveAnalyticEvent({
                event: self.SSAnalyticsService.ANALYTICS_EVENT_VIEWS_DMS_DASHBOARD,
                user_id: self.SSUtilService.getFromLocalStorage('user').id
            }
        );

        self.activeButton = self.BUTTON_MARKETING;
        self.selectedPropertyId = null;
        self.showPropertySaleLoader = false;
        self.getProperties();
        self.getAnnouncement();
        // self.getShortcuts();
        self.getAgencies();
    }

    selectButton(btn) {
        const self = this;

        self.activeButton = btn;
    }

    getProperties() {
        const self = this;

        self.properties = [];

        let url = 'sec/developer/properties';
        let params = {
            summary: true,
            status: [
                // self.PROPERTY_STATUS_APPROVED,
                self.PROPERTY_STATUS_LISTED,
                // self.PROPERTY_STATUS_ARCHIVED
            ].join(',')
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                return;
            }

            if (response.data.properties) {
                self.properties = response.data.properties;
                self.properties.sort(function(a, b) {
                    var keyA = new Date(a.updated_at),
                      keyB = new Date(b.updated_at);
                    // Compare the 2 dates
                    if (keyA < keyB) return 1;
                    if (keyA > keyB) return -1;
                    return 0;
                  });
                self.getShortcuts();
                self.setSelectedPropertyId();
                self.getUnitSalesData(false);
                self.$timeout(function () {
                    jQuery("#project-select").niceSelect('update');
                });

                //Get upcoming properties
                self.upcoming_properties = self.properties.filter(x => x.category === SHOWSUITE.PROPERTY_CATEGORY_UPCOMING_LAUNCH);
            }
        });
    }

    getUnitSalesData(isRadioBtnClick = false) {
        const self = this;
        self.show='sales-data';
        self.unitSalesData = [];
        self.agencies = [];
        let url = 'sec/developer/statistics/dashboard2';
        if(!isRadioBtnClick){
            self.gst_inclusive = true;
        }else{
            if(self.gst_inclusive != null){
                url +='?gst_inclusive='+ self.gst_inclusive;
            }
        }
        let params = {
            property_id: self.selectedPropertyId
        };

        self.selected_property = self.properties.find(x => x.id == self.selectedPropertyId);
        self.showPropertySaleLoader= true;
        // loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            // loading(false);
            self.showPropertySaleLoader = false;

            if (response instanceof Error) {
                return;
            }

            self.unitSalesData = response.data.unit_sales_data;
            self.agencies = response.data.agencies;

            self.processUnitSalesData();
            self.showSaleChart();
            self.getGdv();
        });
    }

    processUnitSalesData() {
        const self = this;

        self.totalUnitsCount = 0;
        self.totalSoldUnitsCount = 0;
        self.totalAvailableUnitsCount = 0;

        self.totalUnitsValue = 0;
        self.totalSoldUnitsValue = 0;
        self.totalCommissionValue = 0;


        self.salesByUnitType = {};
        self.saleByFloorPlanType = {};
        self.salesByAgency = {};


        let saleByAgencyDetails = new Array();
        let saleByAgencyDetails123 = new Array();
        saleByAgencyDetails[null]=[];
        saleByAgencyDetails[undefined]=[];
        let agencyId='';






        jQuery.each(self.unitSalesData, function (i, unitSaleData) {

            self.totalUnitsCount += 1;
            self.totalUnitsValue += unitSaleData.price;
            self.saleByAgencyDetails ={};

            // Sales by Unit Type
            let saleByUnitType = null;
            let saleByFloorPlanType = null;
            if (unitSaleData.name in self.salesByUnitType) {
                saleByUnitType = self.salesByUnitType[unitSaleData.name];
            } else {
                saleByUnitType = {
                    name: unitSaleData.name,
                    totalUnitsCount: 0,
                    totalSoldUnitsCount: 0,
                    totalSoldUnitsValue: 0,
                    totalCommissionValue: 0
                };
                self.salesByUnitType[unitSaleData.name] = saleByUnitType;
            }

            if (unitSaleData.floorplan_id in self.saleByFloorPlanType) {
                saleByFloorPlanType = self.saleByFloorPlanType[unitSaleData.floorplan_id];
            } else {
                saleByFloorPlanType = {
                    name: unitSaleData.floorplan_name,
                    totalUnitsCount: 0,
                    totalSoldUnitsCount: 0,
                };
                self.saleByFloorPlanType[unitSaleData.floorplan_id] = saleByFloorPlanType;
            }
            saleByUnitType.totalUnitsCount += 1;
            saleByFloorPlanType.totalUnitsCount += 1;

            if (unitSaleData.status == self.UNIT_STATUS_DRAFT
                || unitSaleData.status == self.UNIT_STATUS_LISTED
                || unitSaleData.status == self.UNIT_STATUS_RESERVED
                || unitSaleData.status == self.UNIT_STATUS_BOOKED
                || unitSaleData.status == self.UNIT_STATUS_SPECIAL_RESERVED
            ) {
                self.totalAvailableUnitsCount += 1;
                if(unitSaleData.status == self.UNIT_STATUS_DRAFT) {
                    unitSaleData.status_desc='draft';
                }else if(unitSaleData.status == self.UNIT_STATUS_LISTED) {
                    unitSaleData.status_desc='Listed';
                }
                else if(unitSaleData.status == self.UNIT_STATUS_RESERVED) {
                    unitSaleData.status_desc='Reserved';
                }
                else if(unitSaleData.status == self.UNIT_STATUS_BOOKED) {
                    unitSaleData.status_desc='Booked';
                }
                else if(unitSaleData.status == self.UNIT_STATUS_SPECIAL_RESERVED) {
                    unitSaleData.status_desc='Special Reserved';
                }
            } else if (unitSaleData.status == self.UNIT_STATUS_SOLD) {
                let price = 0;
                if(self.gst_inclusive == null || self.gst_inclusive){
                    price = (unitSaleData.sale_price ? unitSaleData.sale_price : (unitSaleData.price ? unitSaleData.price : 0));
                }else{
                    price = (unitSaleData.sale_price_gst_exc ? unitSaleData.sale_price_gst_exc : (unitSaleData.sale_price ? unitSaleData.sale_price : (unitSaleData.price ? unitSaleData.price : 0)));
                }
                let commissionPercentage = unitSaleData.agency_commission ? unitSaleData.agency_commission : 0;
                let commission = 0;
                if (price && commissionPercentage) {
                    commission = price * (commissionPercentage / 100);
                }
                unitSaleData.agency_commission_total=commission;
                if(unitSaleData.status == self.UNIT_STATUS_SOLD) {
                    unitSaleData.status_desc='Sold';
                }

                self.totalSoldUnitsCount += 1;
                self.totalSoldUnitsValue += price;
                self.totalCommissionValue += commission;

                saleByUnitType.totalSoldUnitsCount += 1;
                saleByFloorPlanType.totalSoldUnitsCount += 1;
                saleByUnitType.totalSoldUnitsValue += price;
                saleByUnitType.totalCommissionValue += commission;

                // Sales by Agency
                let saleByAgency = null;
                if (unitSaleData.agency_id in self.salesByAgency) {
                    saleByAgency = self.salesByAgency[unitSaleData.agency_id];
                    unitSaleData.agency_info = self.salesByAgency[unitSaleData.agency_id];
                    if(unitSaleData.agency_id) {
                        if(Array.isArray(saleByAgencyDetails[unitSaleData.agency_id]))
                        {
                            saleByAgencyDetails[unitSaleData.agency_id].push(unitSaleData);
                        }
                        else {
                            saleByAgencyDetails[unitSaleData.agency_id]=[];
                            saleByAgencyDetails[unitSaleData.agency_id].push(unitSaleData);
                        }


                    }
                    else if(unitSaleData.agency_id == null) {
                        saleByAgencyDetails[unitSaleData.agency_id].push(unitSaleData);

                    }
                    else if(typeof(unitSaleData.agency_id) == 'undefined') {
                        saleByAgencyDetails[unitSaleData.agency_id].push(unitSaleData);

                    }

                } else {
                    let agency = self.getAgency(unitSaleData.agency_id);

                    unitSaleData.agency_info =  self.getAgency(unitSaleData.agency_id);
                            if(unitSaleData.agency_id) {
                                 if(Array.isArray(saleByAgencyDetails[unitSaleData.agency_id]))
                                 {
                                     saleByAgencyDetails[unitSaleData.agency_id].push(unitSaleData);
                                    }
                                 else {
                                    saleByAgencyDetails[unitSaleData.agency_id]=[];
                                      saleByAgencyDetails[unitSaleData.agency_id].push(unitSaleData);
                                   }



                            }
                             else if(unitSaleData.agency_id == null) {
                             saleByAgencyDetails[unitSaleData.agency_id].push(unitSaleData);

                             }
                             else if(typeof(unitSaleData.agency_id) == 'undefined') {
                                 saleByAgencyDetails[unitSaleData.agency_id].push(unitSaleData);
                             }


                             if(unitSaleData.agency_id=='' && unitSaleData.agency_id != null) {
                                 agencyId='undefined';
                             }
                             else {
                                 agencyId=unitSaleData.agency_id;
                             }
                    saleByAgency = {
                        id: agencyId,
                        name: agency ? agency.name : 'Unknown',
                        totalUnitsCount: 0,
                        totalSoldUnitsCount: 0,
                        totalSoldUnitsValue: 0,
                        totalCommissionValue: 0
                    };
                    agencyId='';

                    self.salesByAgency[unitSaleData.agency_id] = saleByAgency;
                }

                saleByAgency.totalUnitsCount += 1;
                saleByAgency.totalSoldUnitsCount += 1;
                saleByAgency.totalSoldUnitsValue += price;
                saleByAgency.totalCommissionValue += commission;
            }
        });

        // Sort
        self.salesByUnitType = Object.keys(self.salesByUnitType).sort().reduce(
            (obj, key) => {
                obj[key] = self.salesByUnitType[key];
                return obj;
            },
            {}
        );
        self.saleByFloorPlanType = Object.keys(self.saleByFloorPlanType).sort().reduce(
            (obj, key) => {
                obj[key] = self.saleByFloorPlanType[key];
                return obj;
            },
            {}
        );
        //-----

        jQuery.each(self.salesByUnitType, function (i, unitSaleData) {
            if(unitSaleData.totalUnitsCount != 0 || unitSaleData.totalUnitsCount== 'undefined' || unitSaleData.totalUnitsCount== null)
            {
                unitSaleData.percentage = ((unitSaleData.totalSoldUnitsCount/unitSaleData.totalUnitsCount)*100);
            }
        });

        jQuery.each(self.saleByFloorPlanType, function (i, unitSaleData) {
            if(unitSaleData.totalUnitsCount != 0 || unitSaleData.totalUnitsCount== 'undefined' || unitSaleData.totalUnitsCount== null)
            {
                unitSaleData.percentage = ((unitSaleData.totalSoldUnitsCount/unitSaleData.totalUnitsCount)*100);
            }
        });
        self.saleByAgencyDetails=saleByAgencyDetails;
    }

    getAgencies() {
        const self = this;

        self.agencies = null;
        // let params = {
        //     'format': 1
        // };

        loading(true);
        self.SSHttpService.getAPIRequest('agencies').then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data && response.data.agencies)) {
                return;
            }

            self.agencies = response.data.agencies;

            self.filterAvailableAgencies();
        });
    }

    filterAvailableAgencies() {
        const self = this;

        if (self.agencies == null || self.agencyProjects == null)
            return;

        self.availableAgencies = [{
            id: null,
            name: "Please Select"
        }];

        if (self.agencies) {
            jQuery.each(self.agencies, function (i, agency) {
                let agencyProject = self.findAgencyProject(agency.id);
                if (!agencyProject) {
                    self.availableAgencies.push({
                        id: agency.id,
                        name: agency.name
                    });
                }
            });
        }
    }


    findAgency(agencyId) {
        const self = this;

        let agency = null;

        if (self.agencies) {
            jQuery.each(self.agencies, function (i, _agency) {
                if (agencyId == _agency.id) {
                    agency = _agency;
                    return false;
                }
            });
        }

        return agency;
    }

    getAgencyName(agencyId) {
        const self = this;

        let agency = self.findAgency(agencyId);

        return agency ? agency.name : '';
    }


    agencyDetails(agencyId) {
        const self = this;
        self.limit=10;
        self.current=1;
        self.currentAgency=self.saleByAgencyDetails[agencyId];
       // self.tableParams = new self.NgTableParams({page: 1,
           // count: self.limit }, {dataset: self.currentAgency});
        }

    roundOff(value){

        if(!value)
            return 0;

        return Math.floor(value);
        }

    showSaleChart() {
        const self = this;

        Highcharts.chart('sales_chart', {
            chart: {
                backgroundColor: '#ffffff',
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            title: {text: self.totalSoldUnitsCount + ' / ' + self.totalUnitsCount + ' Units Sold'},
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: [{
                name: 'Units',
                colorByPoint: true,
                data: [{
                    name: 'Available',
                    y: self.totalAvailableUnitsCount,
                }, {
                    name: 'Sold',
                    y: self.totalSoldUnitsCount
                }]
            }],
            colors: ['#2a6ebb', '#1f509c'],
            navigation: {
                buttonOptions: {
                    enabled: false
                }
            },
            credits: {
                enabled: false
            }
        });
    }

    getAgency(agencyId) {
        const self = this;

        let agency = null;

        if (self.agencies) {
            jQuery.each(self.agencies, function (i, _agency) {
                if (_agency.id == agencyId) {
                    agency = _agency;
                    return false;
                }
            });
        }

        return agency;
    }

    viewGdv(){
        const self = this;
        self.show='gdv';
        let url = 'sec/developer/properties/'+self.selectedPropertyId+'/gdv';
        let params = {
            include: 'user'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                return;
            }
            self.gdData = response.data;
        });

    }

    viewGdvDetails($index){
        const self = this;
        self.show='gdv-details';
        let url = 'sec/developer/properties/'+self.selectedPropertyId+'/gdv';
        let params = {
            include: 'details'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                return;
            }
            self.gdDetailData = response.data[$index].details;
        });
    }

    backTo(divId){
        const self = this;
        self.show=divId;
    }

    getGdv(){
        const self = this;
        let url = 'sec/developer/properties/'+self.selectedPropertyId+'/gdv/calculate';
        if(self.gst_inclusive != null){
            url +='?gst_inclusive='+ self.gst_inclusive;
        }
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                return;
            }
            // WEB-4643: show only the live GDV (current_gd). The -/+ value against the first stored
            // snapshot is no longer shown. Falls back to initial_gd for an API without the fix.
            self.gd = (response.data.current_gd != null) ? response.data.current_gd : response.data.initial_gd;
            self.gdInitDate = response.data.initial_date;
        });

    }
    restoreGdv(restoreId){
        const self = this;
        let url = 'sec/developer/properties/'+self.selectedPropertyId+'/gdv/restore';
        let params = {
            restore_id: restoreId
        };
        loading(true);
        self.SSHttpService.postAPIRequest(url,params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                return;
            }
            self.viewGdv();
        });

    }

    getAnnouncement() {
        const self = this;

        let url = 'notifications';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                return;
            }

            if (response.data.notifications && response.data.notifications.length > 0) {
                self.announcement = response.data.notifications[response.data.notifications.length - 1];
            }
        });
    }

    updateMarketingSaleTab(seq) {
        const self = this;

        self.DMSSelectedTab += seq;

        if (self.DMSSelectedTab > 2) {
            self.DMSSelectedTab = 1;
        } else if (self.DMSSelectedTab < 1) {
            self.DMSSelectedTab = 2;
        }
    }

    convertSaleAmount(labelValue) {

        // Nine Zeroes for Billions
        return Math.abs(Number(labelValue)) >= 1.0e+9

        ? (Math.abs(Number(labelValue)) / 1.0e+9).toLocaleString('en-US', { minimumFractionDigits: 2 }) + "B"
        // Six Zeroes for Millions 
        : Math.abs(Number(labelValue)) >= 1.0e+6

        ? (Math.abs(Number(labelValue)) / 1.0e+6).toLocaleString('en-US', { minimumFractionDigits: 2 }) + "M"
        // Three Zeroes for Thousands
        : Math.abs(Number(labelValue)) >= 1.0e+3

        ? (Math.abs(Number(labelValue)) / 1.0e+3).toLocaleString('en-US', { minimumFractionDigits: 2 }) + "K"

        : (Math.abs(Number(labelValue))).toLocaleString('en-US', { minimumFractionDigits: 2 });

    }

    redirectToNewProject() {
        window.location.href = '/developer/properties/create';
    }

    redirectToApplication(){
        window.location.href = '/developer/sales/applications'
    }
    redirectToPayment(){
        window.location.href = '/developer/sales/payments'
    }
    redirectToLiveStackView(){
        window.location.href = '/developer/sales/applications/stackview'
    }
    redirectToEOI(){
        window.location.href = '/developer/properties/x/eoi-phases/x'
    }

    initiateProjectPhase() {
        const self = this;

        self.hideModals();

        self.directTo = self.directToPhase;

        self.property_modal = true;
        $('#propertyModal').modal('show');
    }

    updateProjectUnit() {
        const self = this;

        self.hideModals();

        self.directTo = self.directToUnit;

        self.property_modal = true;
        $('#propertyModal').modal('show');
    }

    hideModals() {
        const self = this;

        self.selected_property_error = "";
        self.selected_shortcut_error = "";

        self.property_modal = false;
        self.shortcut_modal = false;

        if ($('#propertyModal').is(':visible')) $('#propertyModal').modal('hide');
        if ($('#shortcutModal').is(':visible')) $('#shortcutModal').modal('hide');
    }

    redirectToProjectFeature() {
        const self = this;

        if (!self.validateProjectFeature()) return;

        self.hideModals();

        if (self.directTo === self.directToPhase) {
            window.location.href = '/developer/properties/' + self.selected_property_id + '/phases';
        } else if (self.directTo === self.directToUnit) {
            window.location.href = '/developer/properties/' + self.selected_property_id + '/units';
        }
    }

    validateProjectFeature() {
        const self = this;

        if (!self.selected_property_id) {
            self.selected_property_error = "Please select a property to proceed."
            return false;
        }

        return true;
    }

    getShortcuts() {
        const self = this;

        self.shortcuts = [];

        for (let i = 0; i < 4; i++) {
            if (!self.properties || self.properties.length <= i) break; // Skip if less than the properties length

            let url = 'properties/' + self.properties[i].id; // Get full data to get thumb image
            loading(true);
            self.SSHttpService.getAPIRequest(url).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    return;
                }
                if (response.data && response.data.property) {
                    self.shortcuts.push({
                        data: '{"property_id":"' + self.properties[i].id + '"}',
                        object: {
                            file_uri: "" + self.SSAppService.getPropertyHeroThumbUrl(response.data.property),
                            name: self.properties[i].name
                        },
                        type: self.SHORTCUT_PROPERTY_TYPE,
                        name: "",
                        user_id: self.properties[i].created_by,
                    });
                }
            });
        }
    }

    redirectShortcut(shortcut) {
        const self = this;

        switch (shortcut.type) {
            case self.SHORTCUT_PROPERTY_TYPE:
                let shortcut_data = JSON.parse(shortcut.data);
                //Find the correct property
                let found_property = self.properties.find(x => x.id == shortcut_data.property_id);

                if (found_property) {
                    window.location.href = '/developer/properties/' + found_property.named_id;
                } else {
                    console.log("Opps something went wrong.");
                }
                break;

            default:
                console.log("Shouldn't happen!!");
                break;
        }
    }

    saveShortcut() {
        const self = this;

        if (!self.validateShortcut()) return;

        self.hideModals();

        let processed_data = '{"property_id": "' + self.selected_shortcut.property_id + '"}';

        let url = '';
        let params = {
            "type": self.SHORTCUT_PROPERTY_TYPE,
            "data": processed_data,
            "name": ""
        };

        if (self.selected_shortcut.id) {
            url = 'sec/shortcuts/' + self.selected_shortcut.id;
            loading(true);
            self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    return;
                }

                if (response.data.shortcut) {
                    self.read_shortcut.data = response.data.shortcut.data;
                    self.read_shortcut.type = response.data.shortcut.type;
                    self.read_shortcut.object = response.data.shortcut.object;
                    self.SSAlertService.success("Success!", "Updated Shortcut.");
                }
            });
        } else {
            url = 'sec/shortcuts';
            loading(true);
            self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    return;
                }

                if (response.data.shortcut) {
                    self.offset = 0;
                    self.getShortcuts();
                    self.SSAlertService.success("Success!", "Created a new Shortcut.");
                }
            });
        }
    }

    validateShortcut() {
        const self = this;

        if (!self.selected_shortcut.property_id) {
            self.selected_shortcut_error = "Please select a property to proceed."
            return false;
        }

        return true;
    }

    editShortcut(shortcut) {
        const self = this;

        let shortcut_data = JSON.parse(shortcut.data);
        shortcut.property_id = parseInt(shortcut_data.property_id);

        self.selected_shortcut = angular.copy(shortcut);
        self.read_shortcut = shortcut;

        self.hideModals();

        self.shortcut_modal = true;
        $('#shortcutModal').modal('show');
    }

    createShortcut() {
        const self = this;

        self.selected_shortcut = {};

        self.hideModals();

        self.shortcut_modal = true;
        $('#shortcutModal').modal('show');
    }

    goToPrevShortcut() {
        const self = this;

        if (self.shortcut_offset > 0) {
            self.shortcut_offset -= 2;
            self.getShortcuts();
        }
    }

    goToNextShortcut() {
        const self = this;

        if (self.shortcut_offset + 2 < self.total_shortcuts) {
            self.shortcut_offset += 2;
            self.getShortcuts();
        }
        
    }

    getPropertyHeroThumbUrl(property) {
        const self = this;
        let thumb = null;

        if (property) {
            let assets = null;

            if (property.property_assets) {
                assets = property.property_assets;
            } else if (property.propertyAssets) {
                assets = property.propertyAssets;
            }

            if (assets) {
                _.forEach(assets, function (asset) {
                    if (asset.type == 2) {
                        thumb = asset.file_uri;
                    }
                });
            }
        }
        return self.getAssetUrl(thumb);
    }

    getAssetUrl(uri) {
        const self = this;
        if (!uri || uri.indexOf('placehold') !== -1) {
            return uri;
        }

        if (self.getServerConfig()) {
            return self.getServerConfig().assets_host + '/' + uri;
        } else {
            return null;
        }
    }

    setSelectedPropertyId() {
        const self = this;

        if (!(self.properties && self.properties.length > 0)) return; // Skip if self.properties array is empty

        if (self.$localStorage['user_property']) {
            if (self.$localStorage['user_property'].user_id == self.$localStorage['user'].id) {
                let property = self.properties.find(x => x.named_id == self.$localStorage['user_property'].property_id);
                if (property) {
                    self.selectedPropertyId = property.id;
                } else  {
                    self.selectedPropertyId = self.properties[0].id;
                }
            } else {
                self.selectedPropertyId = self.properties[0].id;
            }
        } else {
            self.selectedPropertyId = self.properties[0].id;
        }
    }
}

DeveloperDashboardController.$inject = ['$timeout', '$localStorage', 'SSHttpService', 'SSUtilService', 'SSAnalyticsService', 'SSUserService', 'SSAppService', 'SSAlertService'];
app.controller('DeveloperDashboardController', DeveloperDashboardController);